import React from "react";
import "./Card.css"
import{Link} from 'react-router-dom';
function Card(){
    return(
        
        <div className="newSec1">
        <div className="newSec">
        <div className="image"></div>
        <div className="text">
        <Link style={{textDecoration: 'none'}} to="/foods"><h2 className="order">Order Online</h2></Link>
        <h4 className="stay1">Stay Home and Order to Door step</h4>
        </div>
        </div>
        </div>
        
    )
}
export default Card